<template>
    <div v-if="open" class="conflict-banner v-flex">
        <v-icon color="error" size="22" class="mr-2">mdi-alert-octagon-outline</v-icon>

        <div class="conflict-text">
            <div class="font-weight-medium">
                {{ $t('disposition.inspection.deviceType.conflict.title') }}
            </div>
            <div>{{ text }}</div>
            <div class="conflict-hint">
                {{ $t('disposition.inspection.deviceType.conflict.hint') }}
            </div>
        </div>

        <v-spacer />

        <div class="v-flex conflict-actions">
            <v-btn
                v-if   = "inspection.unit && inspection.unit.id"
                small
                outlined
                color  = "primary"
                class  = "mr-2"
                @click = "$emit('unit', inspection.unit)"
            >
                {{ $t('disposition.inspection.deviceType.conflict.unit') }}
            </v-btn>
            <v-btn
                small
                color    = "primary"
                :loading = "checking"
                @click   = "$emit('check')"
            >
                {{ $t('disposition.inspection.deviceType.conflict.check') }}
            </v-btn>
        </div>
    </div>
</template>

<script>
import DeviceTypeConflict, { CONFLICT, NOT_FOUND } from "@/modules/dis/service/inspection/DeviceTypeConflict";

/**
 * Hint on an inspection with a device type conflict (HCIT-943): what the app reported and how the unit is listed,
 * with the unit dialog to correct the site type and the check against masterdata-svc ("Erneut prüfen").
 */
export default {
    name: "PInspectionDeviceTypeConflict",

    props: {
        inspection: {

        },

        /** A check is running. */
        checking: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        }
    },

    computed: {
        open () {
            return DeviceTypeConflict.isOpen(this.inspection);
        },

        message () {
            return DeviceTypeConflict.message(this.inspection);
        },

        text () {
            const message = this.message;
            if (!message) {
                return this.$t('disposition.inspection.deviceType.conflict.unknown');
            }

            const siteTypes = this.$store.getters.msd ? this.$store.getters.msd.siteType : [];
            const parameters = DeviceTypeConflict.messageParameters(
                message, siteTypes, key => this.$t('disposition.inspection.deviceType.' + key));

            switch (message.errorId) {
                case CONFLICT : return this.$t('masterdata.site.deviceType.conflict.message', parameters);
                case NOT_FOUND: return this.$t('masterdata.site.notfound.message', parameters);
            }

            return this.$t('disposition.inspection.deviceType.conflict.unknown');
        },
    }
}
</script>

<style scoped>

.conflict-banner {
    align-items: flex-start;
    margin: 6px 0 4px 0;
    padding: 8px 12px;
    border: 1px solid var(--v-error-base);
    border-radius: 4px;
    background-color: #fff4f4;
}

.conflict-text {
    font-size: 14px;
    min-width: 0;
}

.conflict-hint {
    font-size: 12px;
    color: grey;
    margin-top: 2px;
}

.conflict-actions {
    align-items: center;
    padding-left: 12px;
    white-space: nowrap;
}

</style>
